import * as React from 'react';

type PickImageProps = {
  children: React.ReactNode;
  accept?: string;
  multiple?: boolean;
  onChange: (file: File[]) => void;
  id: string;
  disabled?: boolean;
  classes?: string;
};

export default function PickMedia({
  children,
  multiple,
  onChange,
  id,
  accept = 'image/*,video/*',
  classes,
  ...props
}: PickImageProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target;
    onChange(files ? Array.from(files) : []);

    event.target.value = '';
  };
  return (
    <div className={classes}>
      <input
        accept={accept}
        style={{ display: 'none' }}
        id={id}
        multiple={multiple}
        onChange={handleChange}
        type="file"
        {...props}
      />
      <label htmlFor={id}>{children}</label>
    </div>
  );
}
